import React, { useMemo } from "react";
import { MONTH_NAMES, sortByDate } from "../../lib/format";
import { DateCard } from "../DateCard";

export const ListView = ({ entries, onOpenDetail }) => {
  const grouped = useMemo(() => {
    const sorted = [...entries].sort(sortByDate);
    const map = new Map();
    for (const e of sorted) {
      const key = e.month ?? 13;
      if (!map.has(key)) map.set(key, []);
      map.get(key).push(e);
    }
    return Array.from(map.entries()).sort((a, b) => a[0] - b[0]);
  }, [entries]);

  if (entries.length === 0) {
    return <EmptyState />;
  }

  return (
    <div data-testid="list-view" style={{ display: "flex", flexDirection: "column", gap: "3rem" }}>
      {grouped.map(([monthIdx, items]) => (
        <section key={monthIdx} aria-labelledby={`month-${monthIdx}`}>
          <header style={{
            display: "flex", alignItems: "baseline", gap: 16, marginBottom: "1.25rem",
            paddingBottom: "0.5rem", borderBottom: "1px solid hsl(var(--line))",
          }}>
            <h3 id={`month-${monthIdx}`} className="archival-figure" style={{
              fontFamily: "var(--font-display)",
              fontSize: "1.5rem",
              fontWeight: 500,
              margin: 0,
            }}>
              {monthIdx === 13 ? "Year-round / movable dates" : MONTH_NAMES[monthIdx]}
            </h3>
            <span style={{ fontSize: "0.78rem", letterSpacing: "0.14em", textTransform: "uppercase", color: "hsl(var(--muted))" }}>
              {items.length} {items.length === 1 ? "entry" : "entries"}
            </span>
          </header>
          <div style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
            gap: "1rem",
          }}>
            {items.map((e) => (
              <DateCard key={e.id} entry={e} onOpen={onOpenDetail} variant="compact" />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

const EmptyState = () => (
  <div data-testid="empty-state" style={{
    padding: "4rem 1rem",
    textAlign: "center",
    border: "1px dashed hsl(var(--line))",
  }}>
    <p style={{ fontFamily: "var(--font-display)", fontStyle: "italic", fontSize: "1.15rem", margin: 0 }}>
      No entries match these filters yet.
    </p>
    <p style={{ fontSize: "0.9rem", color: "hsl(var(--muted))", marginTop: 8 }}>
      Try clearing a filter, or suggest a date that should be added.
    </p>
  </div>
);
